import {
  Design,
  DesignMetaDataBreakingChange
} from '../../../types';

/** Add breaking change to the design. */
export function addBreakingChange(
  design: Design,
  breakingChange: DesignMetaDataBreakingChange
) {
  design.metaData = {
    ...design.metaData,
    breakingChanges: [
      breakingChange,
      ...(design.metaData?.breakingChanges ?? [])
    ]
  };
}
